import { useLocation as useReachRouterLocation, WindowLocation as ReachRouterWindowLocation } from "@reach/router";

export type WindowLocation<S> = Omit<ReachRouterWindowLocation, "state"> & { state?: S };

export const useLocation = <S extends Record<string, unknown>>(): WindowLocation<S> =>
  useReachRouterLocation() as WindowLocation<S>;
